import { FAQItem } from './components/faqs'

export const pricingData = {
  plans: [
    {
      id: 2,
      name: 'Ad-free',
      features: ['Ad-free experience', 'Priority support'],
    },
    {
      id: 1,
      name: 'Premium',
      features: [
        'Ad-free experience',
        'Chat with AI Coach',
        'AI-powered personalized feedback',
        'Advanced error pattern analysis',
        'Custom practice exercises',
        'Priority support',
      ],
    },
  ],
  keyBenefits: [
    { title: 'Ad-Free Experience', description: 'Focus on your typing without distractions.' },
    {
      title: 'Chat with AI Coach',
      description: 'Get real-time assistance and personalized tips from our typing coaches.',
    },
    {
      title: 'AI-Driven Learning',
      description: 'Our artificial intelligence analyzes your typing patterns to create personalized learning paths.',
    },
    {
      title: 'Real-time Feedback',
      description: 'Get instant feedback on your errors and suggestions for improvement.',
    },
    {
      title: 'Progress Tracking',
      description: 'Monitor your typing speed, accuracy, and progress over time with detailed analytics.',
    },
    {
      title: 'Custom Exercises',
      description: 'Practice with exercises tailored to address your specific weak points.',
    },
  ],
}

export const faqItems: FAQItem[] = [
  {
    question: "What's the difference between Ad-free and Premium plans?",
    answer:
      'The Ad-free plan removes all advertisements from your practice sessions, allowing you to focus solely on improving your typing skills. The Premium plan includes everything in the Ad-free plan plus AI-powered coaching, personalized feedback, custom exercises, and advanced analytics.',
  },

  {
    question: 'Can I switch between plans?',
    answer:
      "Yes, you can switch between plans at any time. If you upgrade from Ad-free to Premium, you'll get immediate access to all premium features. If you downgrade from Premium to Ad-free, you'll maintain your ad-free experience but lose access to premium features.",
  },
  {
    question: 'What happens after my trial ends?',
    answer: 'After your 7-day trial ends, you will be automatically charged for the plan you selected.',
  },
  {
    question: 'Can I cancel my subscription?',
    answer:
      "Yes, you can cancel your subscription at any time. If you cancel, you'll continue to have access to your subscription benefits until the end of your trial period or current billing cycle.",
  },
]
